import _styled from '@emotion/styled-base';
import React__default from 'react';
import { DropdownMenu } from '../dropdown-menu/dropdown-menu.js';
import { IconOnlyButton } from '../icon-only-button/icon-only-button.js';
import { TooltipV2 } from '../tooltip-v2/tooltip-v2.js';
import { RulerAlt32, Folder32, AddAlt32 } from '@carbon/icons-react';

var ConditionBuilderFooterPlaceholder = /*#__PURE__*/_styled("div", {
  target: "e15k4jyp0"
})({
  name: "3wzt8g",
  styles: "margin-top:-0.5rem;pointer-events:none;"
});
var ConditionBuilderFooter = function ConditionBuilderFooter(_ref) {
  var addConditionText = _ref.addConditionText,
      addSubConditionText = _ref.addSubConditionText,
      depth = _ref.depth,
      dispatch = _ref.dispatch,
      groupId = _ref.groupId,
      maxDepth = _ref.maxDepth,
      subConditionMaxLimitText = _ref.subConditionMaxLimitText;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "vds-condition-builder-footer"
  }, maxDepth > 0 ? /*#__PURE__*/React__default.createElement(DropdownMenu.Menu, {
    content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DropdownMenu.Item, {
      icon: RulerAlt32,
      onSelect: function onSelect() {
        dispatch({
          type: "ADD_CHILD",
          payload: {
            groupId: groupId,
            type: "rule"
          }
        });
      },
      text: addConditionText
    }), /*#__PURE__*/React__default.createElement(TooltipV2, {
      content: subConditionMaxLimitText,
      disabled: depth < maxDepth
    }, /*#__PURE__*/React__default.createElement(DropdownMenu.Item, {
      disabled: depth >= maxDepth,
      icon: Folder32,
      onSelect: function onSelect() {
        dispatch({
          type: "ADD_CHILD",
          payload: {
            groupId: groupId,
            type: "group"
          }
        });
      },
      text: addSubConditionText
    }))),
    target: /*#__PURE__*/React__default.createElement(IconOnlyButton, {
      fill: true,
      icon: AddAlt32,
      minimal: true,
      text: addConditionText,
      type: "button"
    })
  }) : /*#__PURE__*/React__default.createElement(IconOnlyButton, {
    fill: true,
    icon: AddAlt32,
    minimal: true,
    onClick: function onClick() {
      dispatch({
        type: "ADD_CHILD",
        payload: {
          groupId: groupId,
          type: "rule"
        }
      });
    },
    text: addConditionText,
    type: "button"
  }));
};

export { ConditionBuilderFooter, ConditionBuilderFooterPlaceholder };
//# sourceMappingURL=condition-builder-footer.js.map
